// store/index.js
import axios from "axios";

const state = {
  isAuthenticated: false,
  token: null,
  loginError: null,
  loader: false,
};

const mutations = {
  SET_AUTHENTICATED(state, isAuthenticated) {
    state.isAuthenticated = isAuthenticated;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_LOADER(state, loader) {
    state.loader = loader;
  },
  STOP_LOGIN(state, errorLogin) {
    state.loader = false;
    state.loginError = errorLogin;
  },
};
const actions = {
  async login({ commit }, credentials) {
    commit("SET_LOADER", true);
    try {
      await axios
        .post("ministries/login", credentials)
        .then((response) => {
          if (response.status === 200) {
            const token = response.data.data.token;
            commit("SET_TOKEN", token);
            commit("SET_AUTHENTICATED", true);
            localStorage.setItem("token", token);
            window.location.href = "/home";
          }
        })
        .finally(() => {
          commit("SET_LOADER", false);
        });
    } catch (e) {
      if (e) {
        commit("STOP_LOGIN", "البريد الإلكتروني أو كلمة المرور غير صالحة.   ");
      }
    }
  },

  logout({ commit }) {
    commit("SET_TOKEN", null);
    commit("SET_AUTHENTICATED", false);
    localStorage.removeItem("token");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
